import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Tabs } from "antd";
import { RATypography } from "../Typography";

export const RATabs = ({ tabRenderer = [], onChange, currentTab, slot }) => {
	const [activeKey, setActiveKey] = useState("");

	useEffect(() => {
		if (tabRenderer && tabRenderer.length > 0) {
			let tabKey = !currentTab ? tabRenderer[0].key : currentTab;
			setActiveKey(tabKey);
			onChange?.(tabKey);
		}
	}, [tabRenderer, currentTab, onChange]);

	const renderTabBar = (label, key) => {
		return (
			<TabBarContainer key={key}>
				<RATypography
					variant="sub-heading4"
					color={activeKey === key ? "#222222" : "#A8A8A8"}
					style={{ fontWeight: "400", letterSpacing: 0.3 }}
					classname="ra-tab-bar"
				>
					{label}
				</RATypography>
			</TabBarContainer>
		);
	};

	const _renderTabPaneItems = () => {
		if (tabRenderer.length > 0) {
			return tabRenderer.map((tab, index) => {
				return {
					key: tab.key || index,
					label: renderTabBar(tab.label, tab.key),
					children: tab.render,
				};
			});
		}
	};

	return (
		<TabContainer>
			<Tabs
				defaultActiveKey={activeKey}
				destroyInactiveTabPane={true}
				activeKey={activeKey}
				onChange={(activeKey) => {
					if (onChange && typeof onChange === "function") {
						onChange(activeKey);
					}

					setActiveKey(activeKey);
				}}
				tabBarExtraContent={slot}
				items={_renderTabPaneItems()}
			/>
		</TabContainer>
	);
};

const TabContainer = styled.div`
	width: 100%;
	height: 100%;
	.ant-tabs,
	.ant-tabs-content {
		height: 100%;
	}
	.ant-tabs-tab + .ant-tabs-tab {
		margin: 0 0 0 0;
	}
	.ant-tabs-top > .ant-tabs-nav::before {
		border-color: ${(props) => props.theme.background_500};
		border-width: 2px;
	}
	.ant-tabs-ink-bar {
		background: ${(props) => props.theme.color_primary_500} !important;
	}
`;
const TabBarContainer = styled.div`
	padding-left: 25px;
	padding-right: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 154px;
`;
